import { Navigate } from 'react-router-dom';

function AdminRoute({ children }) {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const userStr = localStorage.getItem('user');
  let userRole = null;

  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      userRole = user.role;
    } catch (error) {
      console.error('Error parsing user from localStorage:', error);
    }
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userRole !== 'admin') {
    // Redirect to dashboard if not admin
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminRoute;
